import React from 'react';

interface ActionBarProps {
  hasResults: boolean;
  onPrint: () => void;
  onExit: () => void;
}

const ActionBar: React.FC<ActionBarProps> = React.memo(({ hasResults, onPrint, onExit }) => {
  return (
    <div className="action-bar">
      <div className="action-group">
        <button
          className="btn btn-primary"
          onClick={onPrint}
          disabled={!hasResults}
          title="列印員工資料表"
        >
          列印
        </button>
      </div>
      <div className="action-separator" />
      <div className="action-group">
        <button className="btn" onClick={onExit}>
          離開
        </button>
      </div>
    </div>
  );
});

ActionBar.displayName = 'ActionBar';

export default ActionBar;
